import React from 'react';
import moment from "moment";
import LinkButton from "../LinkButton";

import "./ManageTable.css"

const ManageTable = ({sites = [], archive}) =>
  <div className="box-100 no-click">
    <table className="w-100">
      <thead>
      <tr>
        <th className="table-header" style={{width: '50px'}} />
        <th className="table-header" style={{width: '275px'}}>LINK</th>
        {!archive && <th className="table-header">CREATED</th>}
        <th className="table-header" style={{width: '275px'}}>ACTIONS</th>
      </tr>
      </thead>
      <tbody className="sites-table">
      {
        sites.map((s,key) => <tr key={key}>
          <td className="ps-3 pe-3 text-center">
            <a>
              <img
                src={archive ? '/website-archived.png' : 'assets/icons/circle-green.svg'}
                height="15px"
                alt="go"
              />
            </a>
          </td>
          <td className="table-domain">
            {archive ? <span>{s.subdomain}</span>
              : <a>
                <span className="highlight">{s.subdomain}</span>
              </a>
            }
          </td>
          {!archive && <td>{moment(s.created).format('DD MMM YY')}</td>}
          <td>
            {!archive && <LinkButton label="UPDATE" />}
            {!archive && <LinkButton label="ARCHIVE" />}
            {archive && <LinkButton label="RELAUNCH" />}
            <LinkButton label="DELETE"/>
            <a>
              <img className="action-icon" src="/download.png" alt="download"/>
            </a>
          </td>
        </tr>)
      }
      </tbody>
    </table>
  </div>;

export default ManageTable;
